export default {
  // 设置页面
  PunchBoardTitle: "戳戳乐-游戏设置",
  candidatesLabel: "候选项目",
  candidatesPlaceholder: "输入候选名字，可用换行或逗号(,)分隔，按下Entert添加项目，最大候选数为20个",
  candidateExists: "候选名字已存在",
  maxCandidates: "候选项目数量已达上限 (20)",
  clearSettings: "清空设置",
  saveSettings: "保存设置",
  unsubmittedWarning: "发现输入框中尚有未按下Enter的项目，请确认后再保存!"
}